import { render, staticRenderFns } from "./SecurityPanel.vue?vue&type=template&id=763d387e&scoped=true"
import script from "./SecurityPanel.vue?vue&type=script&lang=js"
export * from "./SecurityPanel.vue?vue&type=script&lang=js"
import style0 from "./SecurityPanel.vue?vue&type=style&index=0&id=763d387e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763d387e",
  null
  
)

export default component.exports